import Button from '@components/Button';
import Row from '@components/Row';
import { InquiryResponse } from '@models/inquiry';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryFooter({ inquiry }:Props) {
    const { t } = useTranslation('inquiry');
    const { push } = useFlow();
    const handleNewInquiry = () => {
        push('InquiryCommentBottomSheet', { inquiryId: inquiry.id });
    };
    const { status } = inquiry;
    return (
        <Row fullWidth spacing={8}>
            {status === 'ANSWERED' && (
                <Button fullWidth
                    variant='secondary'
                    onClick={() => push('CloseInquiryModal', { inquiryId: inquiry.id })} >
                    {t('log.close')}
                </Button>
            )}
            <Button fullWidth
                onClick={handleNewInquiry}
                disabled={ status === 'CLOSED'} >
                {t('log.addInquiry')}
            </Button>
        </Row>
    );
}

export default InquiryFooter;
